import { Avatar, Box, Button, Chip, IconButton, TextField, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useState } from "react";
import { v4 } from "uuid";
import { useChatPdVContext } from "../../../../contexts/atendimento/ChatPdVContext";
import { useMoeda } from "../../../../../core/hooks/useMoeda";
import { IProdutoPedido } from "../../../../interface/IProdutoPedido";
import { IProduto } from "../../../../../produtos/interfaces/IProduto";
import { TipoProduto } from "../../../../../produtos/enum/TipoProduto";
import { acaoPrincipal, contorno, cores, limitarLinhas, texto } from "../../identidade";

export const ChatPdVFormPeso = () => {
    const { produtoFormulario, voltarTela, adicionarProduto, editarProduto } = useChatPdVContext();
    const produto = produtoFormulario as IProduto | IProdutoPedido | undefined;
    const produtoPedido = produtoFormulario as IProdutoPedido | undefined;
    const isEdicao = !!(produtoPedido as any)?.uuidProdutoReferencia && !!(produtoPedido as any)?.gramas;
    const { real } = useMoeda();

    const [gramas, setGramas] = useState<number>((produtoPedido as any)?.gramas ?? 0);

    const configuracaoPeso = produto?.configuracaoPeso ?? (produto as IProduto)?.configuracao;
    const precoPorKg = configuracaoPeso?.precoPorKg ?? 0;
    const valorTeto = configuracaoPeso?.valorTeto;
    const valorBruto = (gramas / 1000) * precoPorKg;
    const precoFinal = valorTeto ? Math.min(valorBruto, valorTeto) : valorBruto;
    const tetoAtingido = !!valorTeto && valorBruto >= valorTeto;

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (!produto) return;

        const dadosProduto: IProdutoPedido = {
            uuid: produtoPedido?.uuid ?? v4(),
            uuidProdutoReferencia: produto.uuid,
            descricao: produto.descricao,
            tipo: TipoProduto.peso,
            preco: precoFinal,
            gramas,
            quantidade: 1,
            imagens: produto.imagens,
            configuracaoPeso: configuracaoPeso as any,
        };

        if (isEdicao) {
            editarProduto(dadosProduto);
        } else {
            adicionarProduto(dadosProduto);
        }
        voltarTela();
    };

    if (!produto) return null;

    return (
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, height: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1.75, py: 1.5, borderBottom: theme => contorno(theme, 0.09), flexShrink: 0 }}>
                <IconButton onClick={voltarTela} size="small">
                    <ArrowBack />
                </IconButton>
                {produto.imagens?.length ? (
                    <Avatar alt={produto.descricao} src={produto.imagens[0].url} sx={{ width: 36, height: 36 }} />
                ) : (
                    <Avatar alt={produto.descricao} src={`${process.env.PUBLIC_URL}/images/produtos/generico.png`} sx={{ width: 36, height: 36 }} />
                )}
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography sx={{ ...texto.titulo, lineHeight: 1.35, ...limitarLinhas(2) }}>{produto.descricao}</Typography>
                    <Typography sx={{ ...texto.apoio, color: 'text.secondary', mt: 0.25 }}>{real(precoPorKg)} / kg</Typography>
                </Box>
            </Box>
            <Box component="form" onSubmit={handleSubmit} sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'auto', minHeight: 0 }}>
                <Box sx={{ p: 1.75, flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <TextField
                        label="Peso (gramas)"
                        type="number"
                        value={gramas || ''}
                        onChange={(e) => setGramas(Math.max(0, parseInt(e.target.value) || 0))}
                        inputProps={{ min: 1, step: 1 }}
                        placeholder="Digite o peso em gramas"
                        autoFocus
                        fullWidth
                    />
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Typography sx={{ fontSize: '22px', fontWeight: 800, letterSpacing: '-0.02em', color: cores.marca[500] }}>{real(precoFinal)}</Typography>
                        {tetoAtingido && <Chip label="Buffet livre" color="success" size="small" />}
                    </Box>
                </Box>
                <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    disabled={gramas <= 0}
                    sx={theme => ({
                        ...acaoPrincipal(theme),
                        flexShrink: 0,
                        height: 56,
                        borderRadius: 0,
                        fontSize: '13px',
                    })}
                >
                    {isEdicao ? "Salvar alterações" : "Adicionar ao carrinho"}
                </Button>
            </Box>
        </Box>
    );
};
